import {
  FORTA_BLACK,
  FORTA_BLUE,
  FORTA_GRAY2,
  FORTA_GRAY5,
  FORTA_ORANGE,
  FORTA_WHITE,
} from '../../../../../utils/colors';

import type { SxProps, Theme } from '@mui/material';

export const ADDITIONAL_FILES_FIELDSET_SX: SxProps<Theme> = {
  position: 'relative',
  border: `1px solid ${FORTA_BLACK}`,
  borderRadius: '8px',
  px: 2,
  pt: 2.5,
  pb: 1,
};

export const ADDITIONAL_FILES_LEGEND_SX: SxProps<Theme> = {
  position: 'absolute',
  top: 0,
  left: 12,
  transform: 'translateY(-50%)',
  px: 0.5,
  bgcolor: FORTA_WHITE,
  fontSize: 14,
  lineHeight: 1.2,
  color: FORTA_BLACK,
};

export const ASSESSMENT_METHOD_VISUAL_CARD_SX: SxProps<Theme> = {
  p: 2,
  border: `1px solid ${FORTA_BLACK}`,
  borderRadius: '10px',
  bgcolor: FORTA_WHITE,
};

export const ASSESSMENT_METHOD_VISUAL_PREVIEW_SX: SxProps<Theme> = {
  display: 'flex',
  width: '100%',
  height: 320,
  mb: 2,
  alignItems: 'center',
  justifyContent: 'center',
};

export const ASSESSMENT_METHOD_VISUAL_IMAGE_SX: SxProps<Theme> = {
  width: '100%',
  height: '100%',
  objectFit: 'contain',
};

export const MISSING_RECOMMENDED_TOOLS_SX: SxProps<Theme> = {
  color: FORTA_ORANGE,
  fontWeight: 700,
};

export const ASSESSMENT_READINESS_CARD_SX: SxProps<Theme> = {
  p: 2,
  border: `1px solid ${FORTA_BLACK}`,
  borderRadius: '8px',
};

export const ASSESSMENT_READINESS_HEADER_SX: SxProps<Theme> = {
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  alignItems: { xs: 'stretch', md: 'center' },
  justifyContent: 'space-between',
  gap: 2,
  flexWrap: 'wrap',
  width: '100%',
};

export const getAssessmentReadinessExpandIconSx = (expanded: boolean): SxProps<Theme> => [
  {
    p: '2px',
    overflow: 'visible',
    flexShrink: 0,
    lineHeight: 0,
    borderRadius: 2,
    transition: 'transform 150ms',
    '& svg': { display: 'block', overflow: 'visible' },
  },
  expanded
    ? {
        backgroundColor: FORTA_BLUE.primary,
        transform: 'rotate(180deg)',
        '&:hover': { backgroundColor: FORTA_BLUE.dark },
      }
    : {},
];

export const ASSESSMENT_READINESS_DETAILS_SX: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  pt: 3,
};

export const ASSESSMENT_READINESS_SUBSECTION_SX: SxProps<Theme> = {
  p: 2,
  border: `1px solid ${FORTA_BLACK}`,
  borderRadius: '8px',
  gap: 1,
};

export const ASSESSMENT_READINESS_SUBSECTION_HEADER_SX: SxProps<Theme> = {
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  alignItems: { xs: 'stretch', md: 'center' },
  justifyContent: 'space-between',
  gap: 2,
  flexWrap: 'wrap',
  width: '100%',
};

export const ASSESSMENT_READINESS_HEADER_FIELDS_SX: SxProps<Theme> = {
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  alignItems: 'center',
  gap: 2,
  flexShrink: 1,
};

export const ASSESSMENT_READINESS_SCORE_FIELD_SX: SxProps<Theme> = {
  width: { xs: '100%', md: 240 },
};

export const ASSESSMENT_READINESS_OVERALL_SCORE_FIELD_SX: SxProps<Theme> = {
  ...ASSESSMENT_READINESS_SCORE_FIELD_SX,
  '& .MuiInputBase-input': {
    textAlign: 'center',
  },
};

export const ASSESSMENT_READINESS_DATE_FIELD_SX: SxProps<Theme> = {
  width: { xs: '100%', md: 220 },
};

export const ASSESSMENT_READINESS_TABLE_SX: SxProps<Theme> = {
  width: '100%',
};

export const ASSESSMENT_READINESS_VALUE_CELL_SX: SxProps<Theme> = {
  whiteSpace: 'nowrap',
};

export const ASSESSMENT_READINESS_TABLE_HEAD_CELL_SX: SxProps<Theme> = {
  color: FORTA_WHITE,
  backgroundColor: FORTA_BLUE.primary,
  fontWeight: 600,
  borderBottom: 'none',
};

export const ASSESSMENT_READINESS_TABLE_HEAD_VALUE_CELL_SX: SxProps<Theme> = {
  ...ASSESSMENT_READINESS_TABLE_HEAD_CELL_SX,
  ...ASSESSMENT_READINESS_VALUE_CELL_SX,
};

export const ASSESSMENT_READINESS_TOGGLE_GROUP_SX: SxProps<Theme> = {
  flexWrap: 'nowrap',
};

export const ASSESSMENT_SUMMARY_DSM5_FIELD_SX: SxProps<Theme> = {
  '& .MuiInputBase-root': {
    minHeight: 160,
    alignItems: 'flex-start',
  },
};

export const ASSESSMENT_READINESS_TOGGLE_SX: SxProps<Theme> = {
  px: 1.5,
  py: 0.5,
  textTransform: 'none',
  borderColor: FORTA_GRAY2,
  color: FORTA_GRAY5,
  '&.Mui-selected': {
    backgroundColor: FORTA_BLUE.primary,
    color: FORTA_WHITE,
    '&:hover': {
      backgroundColor: FORTA_BLUE.dark,
    },
  },
};
